import {useSearchParam} from "react-use";
import {runApi} from "../services/api/ApiContext";
import {useOktaAuth} from "@okta/okta-react";
import {useEffect, useState} from "react";
import {getApplicationState, setApplicationState, START_LINK_IDP} from "../services/common";
import {getIdps} from "../services/api/socialIdentityApi";
import {getTokenizedId} from "../services/api/internal";
import {extract} from "../utils/jwt";

const loginDomain = process.env.REACT_APP_OKTA_DOMAIN;

const getTokenizedIdProcess = ({data}) => {
    if (!data?.data?.access_token) {
        return {error: true, id: null}
    }

    const jwt = extract(data?.data?.access_token);

    return {id: jwt?.sub, error: false};
}

const LinkOidcView = (idpName) => {
    const oktaAuth = useOktaAuth();
    const code = useSearchParam('code');
    const state = useSearchParam('state');
    const [externalId, setExternalId] = useState(null);
    const [error, setError] = useState(false);
    const [idpId, setIdpId] = useState(null);

    useEffect(() => {
        const fetchId = async () => {
            const idps = await runApi(['idps'], getIdps, (data) => data, {}, true);
            const data = await runApi(['oidc-tokenized-id', code, state], () => getTokenizedId(code, idpName, state), getTokenizedIdProcess, {}, true)

            if(idps?.data?.data?.idps) {
                for(const idp of idps.data.data.idps) {
                    if(idp.name.toLowerCase().indexOf(idpName) > -1) {
                        setIdpId(idp.id);
                        break;
                    }
                }
            }

            if (data?.error) {
                setError(true)
            }

            if (data.id) {
                setExternalId(data.id)
            }
        }

        fetchId().then(_ => {});
    })

    const redirectToLoginOkta = () => oktaAuth.oktaAuth.signInWithRedirect({
        scopes: ['openid', idpName]
    })

    if(externalId && idpId) {
        const appState = getApplicationState();
        appState.state = START_LINK_IDP;
        appState.link = {
            idpId: idpId,
            externalId,
            idpName: idpName
        };
        setApplicationState(appState);

        redirectToLoginOkta().then(_ => {});
    }

    if(error) {
        window.location.replace(`https://${loginDomain}`)
    }


    // Save link state
    // Redirect to login - with iamsmart scope

    return (<></>)
}

export const LinkAppleView = () => LinkOidcView("apple");
export const LinkFacebookView = () => LinkOidcView("facebook");
export const LinkLinkedInView = () => LinkOidcView("linkedin");
export const LinkGoogleView = () => LinkOidcView("google");
export const LinkIAmSmartView = () => LinkOidcView("iamsmart");
